import { LocalizedLink as Link } from '@/components/LocalizedLink';
import { LandingHeader } from '@/components/LandingHeader';
import { LandingFooter } from '@/components/LandingFooter';
import { useDocumentHead } from '@/hooks/useDocumentHead';

export function NotFoundPage() {
  useDocumentHead({
    title: 'Page not found — LogPulse',
    description: 'The page you are looking for does not exist on logpulse.io.',
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 flex flex-col">
      <LandingHeader />
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          <p className="text-sm font-medium text-primary-600 dark:text-primary-400 mb-3">404</p>
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Page not found
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
            We couldn't find the page you're looking for. It may have been moved or never existed.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center px-5 py-2.5 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-700 transition"
            >
              Back to home
            </Link>
            <Link
              to="/docs/getting-started/quickstart"
              className="inline-flex items-center px-5 py-2.5 rounded-xl border border-gray-300 dark:border-gray-700 text-gray-900 dark:text-white font-medium hover:bg-gray-50 dark:hover:bg-gray-900 transition"
            >
              Browse docs
            </Link>
          </div>
        </div>
      </main>
      <LandingFooter />
    </div>
  );
}
